module.exports = __webpack_public_path__ + "img/icon_attribute_mysterious.3df647e3.png";